import { AddOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import BulkOperationReportModal from "@/components/bulk-operation-report-modal";
import SysAccountWriteModal from "@/module/accounts-module/components/sys-account-write-modal";
import { useSaveNewAccount } from "@/module/accounts-module/hooks/accounts-mutate-hooks";
import { ResultDtoSysAccountRegularDto } from "@/shared/api";

const CreateServiceAccountTableControl = ({
  roomName,
  onSuccess,
}: {
  roomName: string;
  onSuccess?: () => void;
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [operationResult, setOperationResult] = useState<ResultDtoSysAccountRegularDto[]>();

  const { mutate: handleClickSaveNewAccount, isPending: createAccountIsPending } =
    useSaveNewAccount({
      roomName: roomName,
      successCallback: (response) => {
        setIsOpen(false);
        setOperationResult(response?.data);
        onSuccess && onSuccess();
      },
    });

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        <AddOutlined />
        {t("new")}
      </Button>
      <SysAccountWriteModal
        mode="add"
        accountType="service"
        isOpen={isOpen}
        roomName={roomName}
        onSave={(name, account) => handleClickSaveNewAccount({ name, ...account })}
        onClose={() => setIsOpen(false)}
        confirmLoading={createAccountIsPending}
      />

      {operationResult != null && (
        <BulkOperationReportModal
          open
          showProblematic
          showSuccess
          title={t("importAccountsTableControl.operationResultTitle")}
          resultList={operationResult}
          onCancel={() => setOperationResult(undefined)}
        />
      )}
    </>
  );
};

export default CreateServiceAccountTableControl;
